/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

// BASE
import { ROOT_SLICE as ROOT_SLICE_BASE } from './slices/Base/constants';
import { initialState as BaseInitialState } from './slices/Base/initialState';
import BaseReducerParts from './slices/Base/reducerParts';

// CUSTOMERS
import { ROOT_SLICE as ROOT_SLICE_CUSTOMERS } from './slices/Customers/constants';
import { initialState as CustomersInitialState } from './slices/Customers/initialState';
import CustomersReducerParts from './slices/Customers/reducerParts';

// SUPERVISORS
import { ROOT_SLICE as ROOT_SLICE_SUPERVISORS } from './slices/Supervisors/constants';
import { initialState as SupervisorsInitialState } from './slices/Supervisors/initialState';
import SupervisorsReducerParts from './slices/Supervisors/reducerParts';

// MANAGERS
import { ROOT_SLICE as ROOT_SLICE_MANAGERS } from './slices/ProjectManagers/constants';
import { initialState as ManagersInitialState } from './slices/ProjectManagers/initialState';
import ManagersReducerParts from './slices/ProjectManagers/reducerParts';

// TECHNICIANS
import { ROOT_SLICE as ROOT_SLICE_TECHNICIANS } from './slices/Technicians/constants';
import { initialState as TechniciansInitialState } from './slices/Technicians/initialState';
import TechniciansReducerParts from './slices/Technicians/reducerParts';

// ENTITIES
import { ROOT_SLICE as ROOT_SLICE_ENTITIES } from './slices/Entities/constants';
import { initialState as EntitiesInitialState } from './slices/Entities/initialState';
import EntitiesReducerParts from './slices/Entities/reducerParts';

// AREAS
import { ROOT_SLICE as ROOT_SLICE_AREAS } from './slices/Areas/constants';
import { initialState as AreasInitialState } from './slices/Areas/initialState';
import AreasReducerParts from './slices/Areas/reducerParts';

// PIPES
import { ROOT_SLICE as ROOT_SLICE_PIPES } from './slices/Pipes/constants';
import { initialState as PipesInitialState } from './slices/Pipes/initialState';
import PipesReducerParts from './slices/Pipes/reducerParts';

// REG STATUS
import { ROOT_SLICE as ROOT_SLICE_REG_STATUS } from './slices/RegulatoryStatus/constants';
import { initialState as RegStatusInitialState } from './slices/RegulatoryStatus/initialState';
import RegStatusReducerParts from './slices/RegulatoryStatus/reducerParts';

// STATUSES
import { ROOT_SLICE as ROOT_SLICE_STATUSES } from './slices/Statuses/constants';
import { initialState as StatusesInitialState } from './slices/Statuses/initialState';
import StatusesReducerParts from './slices/Statuses/reducerParts';

// LINES
import { ROOT_SLICE as ROOT_SLICE_LINES } from './slices/Lines/constants';
import { initialState as LinesInitialState } from './slices/Lines/initialState';
import LinesReducerParts from './slices/Lines/reducerParts';

// JOBS
import { ROOT_SLICE as ROOT_SLICE_JOBS } from './slices/Jobs/constants';
import { initialState as JobsInitialState } from './slices/Jobs/initialState';
import JobsReducerParts from './slices/Jobs/reducerParts';

// AEGION PMS
import { ROOT_SLICE as ROOT_SLICE_AEGION_PMS } from './slices/AegionProjectManagers/constants';
import { initialState as AegionPmsInitialState } from './slices/AegionProjectManagers/initialState';
import AegionPmsReducerParts from './slices/AegionProjectManagers/reducerParts';

// FORM STATE JOBLINE
import { ROOT_SLICE as ROOT_SLICE_AEGION_FORM_STATE_JOBLINE } from './slices/FormStateJobLine/constants';
import { initialState as FormStateJobLineInitialState } from './slices/FormStateJobLine/initialState';
import FormStateJobLineReducerParts from './slices/FormStateJobLine/reducerParts';

const initialState = {
	[ROOT_SLICE_BASE]: {
		...BaseInitialState
	},
	[ROOT_SLICE_CUSTOMERS]: {
		...CustomersInitialState
	},
	[ROOT_SLICE_SUPERVISORS]: {
		...SupervisorsInitialState
	},
	[ROOT_SLICE_MANAGERS]: {
		...ManagersInitialState
	},
	[ROOT_SLICE_TECHNICIANS]: {
		...TechniciansInitialState
	},
	[ROOT_SLICE_ENTITIES]: {
		...EntitiesInitialState
	},
	[ROOT_SLICE_AREAS]: {
		...AreasInitialState
	},
	[ROOT_SLICE_PIPES]: {
		...PipesInitialState
	},
	[ROOT_SLICE_REG_STATUS]: {
		...RegStatusInitialState
	},
	[ROOT_SLICE_STATUSES]: {
		...StatusesInitialState
	},
	[ROOT_SLICE_LINES]: {
		...LinesInitialState
	},
	[ROOT_SLICE_JOBS]: {
		...JobsInitialState
  },
  [ROOT_SLICE_AEGION_PMS]: {
    ...AegionPmsInitialState
  },
  [ROOT_SLICE_AEGION_FORM_STATE_JOBLINE]: {
    ...FormStateJobLineInitialState
  },
};

const reducerParts = {
  ...BaseReducerParts,
  ...CustomersReducerParts,
	...SupervisorsReducerParts,
  ...ManagersReducerParts,
  ...TechniciansReducerParts,
  ...EntitiesReducerParts,
  ...AreasReducerParts,
  ...PipesReducerParts,
  ...RegStatusReducerParts,
  ...StatusesReducerParts,
  ...LinesReducerParts,
  ...JobsReducerParts,
  ...AegionPmsReducerParts,
  ...FormStateJobLineReducerParts,
};

export { ROOT_SLICE } from './constants';
export default handleActions(reducerParts, initialState);
